module.exports = __webpack_public_path__ + "img/DK67020618.c508eb59.svg";